import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator action to set selectedFolderId in Mail Store.
 * WI #87449 : Use this action to set the selectedFolderId wherever needed in mail.
 */
export const setSelectedFolderId = mutatorAction('setSelectedFolderId', (folderId: string) => {
    getStore().folders.selectedFolderId = folderId;
});
